import { cn } from "@/modern/utils";

function Shimmer({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <div
      aria-hidden
      style={style}
      className={cn(
        "relative overflow-hidden rounded-md bg-muted/70 before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer",
        "before:bg-gradient-to-r before:from-transparent before:via-foreground/[0.08] before:to-transparent motion-reduce:before:animate-none",
        className
      )}
    />
  );
}

const ROWS = [0, 1, 2, 3, 4, 5];

export function CheckgridsRailSkeleton() {
  return (
    <div className="flex flex-col gap-1" aria-busy="true" aria-label="Loading checklists">
      {ROWS.map((row) => (
        <div key={row} className="rounded-lg py-3 pr-10 pl-3.5">
          <Shimmer className="h-3.5" style={{ width: `${78 - (row % 3) * 12}%` }} />
          <Shimmer className="mt-2 h-2.5 w-2/5" />
          <Shimmer className="mt-3 h-1 w-full rounded-full" />
        </div>
      ))}
    </div>
  );
}

export function CheckgridsOverviewSkeleton() {
  return (
    <section aria-busy="true" aria-label="Loading checklists">
      <div className="mb-2 flex items-center gap-2">
        <Shimmer className="h-3 w-24" />
        <Shimmer className="h-3 w-4" />
      </div>
      <div className="overflow-hidden rounded-lg border border-border bg-card">
        <div className="min-w-[720px] divide-y divide-border/70">
          {ROWS.map((row) => (
            <div key={row} className="flex items-center justify-between gap-6 px-5 py-4">
              <div className="min-w-0 flex-1">
                <Shimmer className="h-4" style={{ width: `${34 - (row % 3) * 6}%` }} />
                <Shimmer className="mt-2 h-3 w-1/4" />
              </div>
              <div className="w-[113px] shrink-0">
                <Shimmer className="ml-auto h-3 w-10" />
                <Shimmer className="mt-2 h-1 w-full rounded-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
